import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { KeyboardService } from '@freelancer/keyboard';
import { StickyBehaviour, StickyPosition } from '@freelancer/ui/sticky';
import * as Rx from 'rxjs';
import { StickyFooterPosition } from './sticky-footer.types';

@Component({
  selector: 'fl-sticky-footer',
  template: `
    <fl-bit
      *ngIf="position === StickyFooterPosition.FIXED"
      class="StickyFooterContainer"
      [attr.data-full-width]="fullWidth"
      [flSticky]="true"
      [flStickyStatic]="stickyStatic"
      [flStickyPosition]="StickyPosition.BOTTOM"
      [flStickyBehaviour]="StickyBehaviour.ALWAYS"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </fl-bit>

    <ng-container *ngIf="position === StickyFooterPosition.ABSOLUTE">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>

    <ng-template #content>
      <fl-bit
        class="StickyFooter"
        [ngClass]="{
          IsKeyboardOpen: isKeyboardOpen$ | flAsync,
          IsHidden: (isKeyboardOpen$ | flAsync) && hideOnKeyboardActive
        }"
        [attr.data-position]="position"
        [attr.data-box-shadow]="boxShadow"
      >
        <ng-content></ng-content>
      </fl-bit>
    </ng-template>
  `,
  styleUrls: ['./sticky-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyFooterComponent implements OnInit {
  StickyFooterPosition = StickyFooterPosition;
  StickyBehaviour = StickyBehaviour;
  StickyPosition = StickyPosition;

  isKeyboardOpen$: Rx.Observable<boolean>;

  @Input() position = StickyFooterPosition.ABSOLUTE;
  @Input() boxShadow = true;
  @Input() stickyStatic = false;
  @Input() fullWidth = true;

  // Hide when virtual keyboard is open
  // Note: This only for native apps
  @Input() hideOnKeyboardActive = true;

  constructor(private keyboardService: KeyboardService) {}

  ngOnInit() {
    this.isKeyboardOpen$ = this.keyboardService.isOpen();
  }
}
